<template>
  <div class="results-list__container width-responsiveness">
    <Spinner v-if="resultsPdfLoadingStatus" />
    <template v-else>
      <div class="results-list__header">
        <h3>LISTA DE PACIENTES</h3>
        <button
          class="export"
          @click="viewAllResultsInPDF"
        >
          <md-tooltip
            md-delay="400"
            md-direction="top"
          >
            Exportar em PDF
          </md-tooltip>
          Gerar Laudo
          <md-icon
            md-src="/static/images/icon-eye-alt.svg"
            class="icon-download"
          />

          <span
            v-if="resultsSelectedOrders.length > 0"
            class="exams-qtd"
          >
            {{ resultsSelectedOrders.length }}
          </span>
        </button>
      </div>
      <template v-if="resultsPDFList.orders && resultsPDFList.orders.length > 0">
        <table class="apoio-datatable white-head">
          <colgroup>
            <col class="column-check" />
            <col class="column-date" />
            <col class="column-os" />
            <col class="column-patient-name" />
            <col class="column-expected-date" />
            <col class="column-status" />
            <col class="column-export" />
          </colgroup>
          <thead>
            <tr>
              <th class="column-check">
                <div class="styled-checkbox">
                  <input
                    id="chkResultsSelectAll"
                    v-model="selectAll"
                    type="checkbox"
                    :disabled="!isAbleToSelectedAll()"
                  />
                  <label for="chkResultsSelectAll" />
                </div>
                <md-tooltip
                  md-delay="400"
                  md-direction="right"
                >
                  Selecionar todos
                </md-tooltip>
              </th>
              <th
                class="column-date"
                title="Data de Cadastro"
              >
                Data de Cadastro
              </th>
              <th
                class="column-os-alvaro"
                title="OS Alvaro"
              >
                OS Alvaro / Lis
              </th>
              <th
                class="column-patient-name"
                title="Nome Completo"
              >
                Nome Completo
              </th>
              <th
                class="column-expected-date"
                title="Data Prevista"
              >
                Data Prevista
              </th>
              <th class="column-status">Status</th>
              <th class="column-export" />
            </tr>
          </thead>
        </table>

        <table class="apoio-datatable apoio-datatable-alt">
          <colgroup>
            <col class="column-check" />
            <col class="column-date" />
            <col class="column-os" />
            <col class="column-patient-name" />
            <col class="column-expected-date" />
            <col class="column-status" />
            <col class="column-export" />
          </colgroup>
          <tbody
            v-for="(result, index) in resultsPDFList.orders"
            :key="index"
          >
            <tr
              class="apoio-datatable__line apoio-datatable-alt"
              :class="{
                '--bold': hasSomeNewExam(result.examResultDateResponseList),
                '--paternity': hasPaternityExam(result.examResultDateResponseList),
              }"
              @click="toggleResultDetails(result.alvaroId)"
            >
              <td class="column-check">
                <md-icon class="arrow">
                  {{ isSelected(result.alvaroId) ? 'arrow_drop_up' : 'arrow_drop_down' }}
                </md-icon>
              </td>
              <td>
                <span :title="result.createdDate">
                  {{ result.createdDate }}
                </span>
              </td>
              <td>
                <span :title="result.alvaroId">{{ osLisAndAlvaroConcat(result) }}</span>
              </td>
              <td>
                <span :title="result.namePatient">
                  {{ result.namePatient }}
                </span>
              </td>
              <td>
                <span :title="result.promisedDate">
                  {{ result.promisedDate }}
                </span>
              </td>
              <td>
                <ColorBalls
                  :ball-size="14"
                  :ball-font-size="9"
                  :spacing="4"
                  :balls="ballsArray(result)"
                />
              </td>
              <td class="column-export">
                <button
                  class="btn btn-primary btn-inline"
                  @click.stop="goToTraceability(result)"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="left"
                  >
                    Ir para rastreabilidade
                  </md-tooltip>
                  <md-icon
                    md-src="/static/images/traceability.svg"
                    class="icon-pdf traceability"
                  />
                </button>

                <button
                  :disabled="
                    isAbleToClick(result) ||
                    (hasPaternityExam(result.examResultDateResponseList) &&
                      !toggle.paternity)
                  "
                  class="btn btn-primary btn-inline"
                  @click.stop="exportPatientResultsInPDF(result)"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="left"
                  >
                    Exportar selecionados em PDF
                  </md-tooltip>
                  <md-icon
                    md-src="/static/images/icon-pdf-doc.svg"
                    class="icon-pdf"
                  />
                </button>

                <button
                  :disabled="
                    isAbleToClick(result) ||
                    (hasPaternityExam(result.examResultDateResponseList) &&
                      !toggle.paternity)
                  "
                  class="btn btn-primary btn-inline"
                  @click.stop="viewResultInPDF(result)"
                >
                  <md-tooltip
                    md-delay="400"
                    md-direction="left"
                  >
                    Ver selecionados
                  </md-tooltip>
                  <md-icon
                    md-src="/static/images/icon-eye-alt.svg"
                    class="icon-download"
                  />
                </button>
              </td>
            </tr>
            <tr
              v-show="isSelected(result.alvaroId)"
              class="row-details-alt"
            >
              <td
                class="row-details-alt__container"
                colspan="7"
              >
                <ResultsPDFDetails :results-child="result" />
              </td>
            </tr>
          </tbody>
        </table>

        <div>
          <Pagination
            :current-page="currentPage"
            :total-pages="totalPages"
            @page-change="changePage"
          />
        </div>
      </template>
      <div
        v-else
        class="empty-search"
      >
        <md-icon md-src="/static/images/icon-no-tubes-found.svg" />
        <p>Não foi encontrado nenhum resultado.</p>
      </div>
    </template>
  </div>
</template>

<script>
import ResultsPDFDetails from './ResultsPDFDetails'
import Pagination from '@/components/common/Pagination'
import Spinner from '@/components/common/Spinner'
import ColorBalls from '@/components/common/ColorBalls'
import ResultsPDFService from '@/api/resultsPDF'
import notify from '@/api/notification'
import { mapGetters, mapActions } from 'vuex'
import { downloadFileByByteArray } from '@/utils/convertByteArrayToFile'
import mixin from './resultMixin'
import { isPaternityExam, isPaternityOrder } from '@/constants'

export default {
  components: {
    ResultsPDFDetails,
    Pagination,
    Spinner,
    ColorBalls,
  },
  mixins: [mixin],
  props: {
    resultsPDFList: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      selectedItems: [],
    }
  },
  computed: {
    ...mapGetters([
      'resultsPdfFilters',
      'resultsPdfLoadingStatus',
      'resultsSelectedOrders',
      'printConfig',
      'toggle',
    ]),
    currentPage() {
      return this.resultsPDFList.currentPage
    },
    totalPages() {
      return this.resultsPDFList.totalPages
    },
  },
  watch: {
    resultsSelectedOrders: function (newValue) {
      if (newValue.length > 0) {
        const selectedExams = this.resultsPDFList.orders.filter(order => {
          return order.examResultDateResponseList.some(exam =>
            newValue.includes(exam.idItemExam)
          )
        })

        selectedExams.forEach(exam => {
          if (!this.selectedItems.includes(exam.alvaroId)) {
            this.selectedItems.push(exam.alvaroId)
          }
        })
      }
    },
  },
  methods: {
    ...mapActions([
      'getResultsPDFFilter',
      'getServiceResultsPDF',
      'viewResultInPDF',
      'setExamMomentlyAsReaded',
      'viewAllResultsInPDF',
    ]),
    toggleResultDetails(item) {
      const index = this.selectedItems.indexOf(item)

      if (index === -1) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems.splice(index, 1)
      }
    },
    isSelected(id) {
      return this.selectedItems.includes(id)
    },
    changePage(page) {
      let newFilter = this.resultsPdfFilters
      newFilter['page'] = page
      this.getResultsPDFFilter(newFilter)
      this.getServiceResultsPDF()
    },
    osLisAndAlvaroConcat(result) {
      if (result.lisId) {
        return `${result.alvaroId} / ${result.lisId}`
      }
      return `${result.alvaroId}`
    },
    hasPaternityExam(examList) {
      return examList.some(exam => isPaternityExam(exam.mnemonic))
    },
    hasAnyPaternityWithoutToggle() {
      if (this.toggle.paternity) {
        return false
      }

      return (
        this.resultsPDFList.orders?.some(order =>
          this.hasPaternityExam(order.examResultDateResponseList)
        ) || false
      )
    },
    exportPatientResultsInPDF(result) {
      this.$store.commit('setResultsPdfDownloadLoading', true)
      let exams = result.examResultDateResponseList.filter(exam =>
        this.resultsSelectedOrders.includes(exam.idItemExam)
      )
      if (exams.length === 0) {
        exams = result.examResultDateResponseList.filter(exam => exam.resultDate !== '')
      }
      const mnemonics = exams.map(exam => exam.mnemonic)
      const isPaternity = isPaternityOrder(mnemonics)

      ResultsPDFService.downloadResultsPDF(result.alvaroId, mnemonics, isPaternity)
        .then(response => {
          this.$store.commit('setResultsPdfDownloadLoading', false)
          this.setExamMomentlyAsReaded({ alvaroId: result.alvaroId, orders: exams })
          const fileName = result.alvaroId
          const fileExtension = response.headers['content-type']
          downloadFileByByteArray(response.data, fileName, fileExtension)
          notify({
            title: 'AVISO:',
            message: 'Download realizado com sucesso.',
          })
        })
        .catch(() => {
          this.$store.commit('setResultsPdfDownloadLoading', false)
          notify({
            title: 'AVISO:',
            message: this.$strings.resultsPDFErrorsMessages.downloadFail,
          })
        })
    },
    isAbleToClick(result) {
      return !result.examResultDateResponseList.some(exam => exam.resultDate !== '')
    },
    isAbleToSelectedAll() {
      const hasSomeMatches = this.resultsPDFList.orders.some(order => {
        return order.examResultDateResponseList.some(exam => exam.resultDate !== '')
      })

      return hasSomeMatches
    },
    hasSomeNewExam(examList) {
      return examList.some(exam => !exam.generatedInternetDate && exam.resultDate !== '')
    },
    ballsArray(result) {
      return [
        {
          color: this.$strings.statusColorBalls.RECOLLECT.color,
          message: this.$strings.statusColorBalls.RECOLLECT.message,
          number: result.amountRecollected,
        },
        {
          color: this.$strings.statusColorBalls.SUSPENDED.color,
          message: this.$strings.statusColorBalls.SUSPENDED.message,
          number: result.amountSuspended,
        },
        {
          color: this.$strings.statusColorBalls.CANCELED_MATERIAL.color,
          message: this.$strings.statusColorBalls.CANCELED_MATERIAL.message,
          number: result.amountCanceled,
        },
        {
          color: this.$strings.statusColorBalls.PENDING_MATERIAL.color,
          message: this.$strings.statusColorBalls.PENDING_MATERIAL.message,
          number: result.amountPendingMaterial,
        },
        {
          color: this.$strings.statusColorBalls.REGISTERED.color,
          message: this.$strings.statusColorBalls.REGISTERED.message,
          number: result.amountRegistred,
        },
        {
          color: this.$strings.statusColorBalls.RUNNING.color,
          message: this.$strings.statusColorBalls.RUNNING.message,
          number: result.amountRunning,
        },
        {
          color: this.$strings.statusColorBalls.READY.color,
          message: this.$strings.statusColorBalls.READY.message,
          number: result.amountReady,
        },
        {
          color: this.$strings.statusColorBalls.READED.color,
          message: this.$strings.statusColorBalls.READED.message,
          number: result.amountReaded,
        },
      ]
    },
    goToTraceability(result) {
      const url = `/traceability/search?q=${result.alvaroId}&typeOfSearch=OA`
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/mixins';

.results-list {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 24px;
    font-family: 'Exo 2', sans-serif !important;

    h3 {
      color: #7a7a7a;
      font-weight: 500;
      font-size: 18px;
    }

    .export {
      padding: 0 15px;
      border: 1px solid #e8eaed;
      border-radius: 5px;
      background: #7f1a54;
      font-size: 14px;
      text-transform: uppercase;
      font-weight: 600;
      height: 40px;
      cursor: pointer;
      font-family: 'Exo 2', sans-serif !important;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      i.md-icon {
        margin-left: 8px;
        width: 18px;
        min-width: 18px;
      }
    }

    .exams-qtd {
      width: 20px;
      height: 20px;
      background: #fff;
      font-size: 12px;
      color: #801a54;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #801a54;
      border-radius: 50%;
      position: absolute;
      left: -8px;
      top: -8px;
    }
  }

  &__container {
    margin-top: 20px;
    margin-bottom: 50px;
    font-family: 'Exo 2', sans-serif !important;

    .apoio-datatable {
      &__line {
        height: 56px;
        cursor: pointer;

        &.--bold {
          font-weight: 700;
        }

        &.--paternity {
          background-color: #fff3e0 !important;
          border-left: 4px solid #ff9800;
        }

        a {
          color: #797979;
        }
      }

      th {
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }

    .styled-checkbox input[type='checkbox']:checked + label {
      background-color: #691043;
      border: 1px solid #691043;
    }

    .styled-checkbox input[type='checkbox']:active + label:active {
      border: 1px solid #691043;
    }

    .column-check {
      width: 45px;
      padding: 0 0 0 14px;
    }

    .column-date,
    .column-expected-date {
      width: 154px;
    }

    .column-os {
      width: 20%;
    }

    .column-status {
      width: 108px;
    }

    .column-export {
      text-align: center;
      width: 200px;
    }

    .styled-checkbox {
      padding-top: 10px;

      label {
        margin-top: -3px;
        background-color: #ebebeb;
        border: 1px solid #7a7a7a;
      }

      input[type='checkbox'] {
        opacity: 1;
        margin-top: 2px;
      }

      input[type='checkbox']:disabled {
        label,
        & + label {
          border: 1px solid #b0b0b0 !important;
          background-color: #b0b0b0 !important;
        }

        & + label:after {
          opacity: 0;
        }
      }
    }

    .apoio-datatable {
      margin-top: 0;
    }

    .tooltip-size {
      width: 20px;
    }

    .btn-inline {
      min-width: 50px;

      i {
        width: 20px;
        height: 20px;
        min-width: 20px;
        margin: 0;
        padding: 0;

        path {
          fill: white;
        }
      }

      .traceability {
        width: 28px;
        height: 28px;
        margin: 0;
        padding-top: 4px;
      }
    }

    .loader {
      margin: 80px auto;
    }

    .empty-search {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 100px;

      i {
        width: 120px;
        height: 120px;
        margin: auto;
      }

      p {
        font-size: 18px;
        margin-top: 26px;
      }
    }
  }
}
</style>
